const STATIC_SPOTS = [
  {
    spot_id: "seed-crane-beach",
    name: "Crane Beach",
    description:
      "Consistently rated one of the most beautiful beaches in the world, Crane Beach features pink-tinged sands, dramatic cliffs, and crystal-clear turquoise waters.",
    short_description: "World-famous pink sand beach with stunning cliffs",
    category: "beach",
    country: "barbados",
    location: "Crane, St. Philip, Barbados",
    address: "Crane, St. Philip, Barbados",
    image_url: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800",
    images: ["https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800"],
    rating: 4.9,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["beach", "swimming", "sunset", "photography"],
    opening_hours: "daily: 6:00 AM - 6:00 PM",
  },
  {
    spot_id: "seed-bathsheba-beach",
    name: "Bathsheba Beach",
    description:
      "The rugged east coast gem of Barbados, known for its massive boulders, powerful Atlantic waves, and raw natural beauty.",
    short_description: "Dramatic east coast with iconic rock formations",
    category: "beach",
    country: "barbados",
    location: "Bathsheba, St. Joseph, Barbados",
    address: "Bathsheba, St. Joseph, Barbados",
    image_url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800",
    images: ["https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800"],
    rating: 4.7,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["beach", "surfing", "photography", "nature"],
    opening_hours: "daily: Open 24 hours",
  },
  {
    spot_id: "seed-carlisle-bay",
    name: "Carlisle Bay",
    description:
      "A marine park paradise with calm waters, shipwreck snorkeling, and sea turtle encounters. The white sand beach is perfect for families and water sports enthusiasts.",
    short_description: "Marine park with shipwrecks and sea turtles",
    category: "beach",
    country: "barbados",
    location: "Carlisle Bay, Bridgetown, Barbados",
    address: "Carlisle Bay, Bridgetown, Barbados",
    image_url: "https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=800",
    images: ["https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=800"],
    rating: 4.8,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["snorkeling", "sea turtles", "shipwrecks", "family"],
    opening_hours: "daily: 6:00 AM - 6:00 PM",
  },
  {
    spot_id: "seed-the-cliff",
    name: "The Cliff",
    description:
      "Perched on a cliff overlooking the Caribbean Sea, The Cliff offers an unforgettable fine dining experience with award-winning cuisine and impeccable service.",
    short_description: "Iconic cliff-side fine dining with ocean views",
    category: "restaurant",
    country: "barbados",
    location: "Derricks, St. James, Barbados",
    address: "Derricks, St. James, Barbados",
    image_url: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800",
    images: ["https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800"],
    rating: 4.9,
    is_featured: true,
    is_premium_content: true,
    locked: false,
    tags: ["fine dining", "seafood", "romantic", "sunset"],
    phone: "+1 246-432-1922",
    opening_hours: "Mon-Sun: 6:30 PM - 10:00 PM",
  },
  {
    spot_id: "seed-oistins-fish-fry",
    name: "Oistins Fish Fry",
    description:
      "The legendary Friday night fish fry where locals and tourists gather for fresh grilled fish, rum punch, and live music.",
    short_description: "Legendary Friday night fish fry experience",
    category: "restaurant",
    country: "barbados",
    location: "Oistins, Christ Church, Barbados",
    address: "Oistins, Christ Church, Barbados",
    image_url: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800",
    images: ["https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800"],
    rating: 4.6,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["local food", "seafood", "nightlife", "music"],
    opening_hours: "Fri-Sat: 5:00 PM - 12:00 AM",
  },
  {
    spot_id: "seed-harbour-lights",
    name: "Harbour Lights",
    description:
      "Barbados' premier beach club and nightlife venue. Dance under the stars on the sand with world-class DJs, fire dancers, and Caribbean vibes.",
    short_description: "Premier beach club with fire dancers",
    category: "nightclub",
    country: "barbados",
    location: "Bay Street, Bridgetown, Barbados",
    address: "Bay Street, Bridgetown, Barbados",
    image_url: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800",
    images: ["https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800"],
    rating: 4.5,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["nightclub", "beach party", "dancing", "live music"],
    opening_hours: "Wed, Fri: 9:00 PM - 3:00 AM",
  },
  {
    spot_id: "seed-harrisons-cave",
    name: "Harrison's Cave",
    description:
      "A crystallized limestone cavern featuring flowing streams, deep pools, and stunning stalactites and stalagmites.",
    short_description: "Stunning underground crystallized cavern",
    category: "attraction",
    country: "barbados",
    location: "Welchman Hall, St. Thomas, Barbados",
    address: "Welchman Hall, St. Thomas, Barbados",
    image_url: "https://images.unsplash.com/photo-1504699011882-6c0c75e5c07c?w=800",
    images: ["https://images.unsplash.com/photo-1504699011882-6c0c75e5c07c?w=800"],
    rating: 4.8,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["nature", "cave", "family", "tour"],
    opening_hours: "daily: 8:45 AM - 3:45 PM",
  },
  {
    spot_id: "seed-st-nicholas-abbey",
    name: "St. Nicholas Abbey",
    description:
      "One of only three genuine Jacobean mansions in the Western Hemisphere. Tour the historic plantation house and enjoy rum tastings.",
    short_description: "Historic rum plantation and mansion",
    category: "attraction",
    country: "barbados",
    location: "Cherry Tree Hill, St. Peter, Barbados",
    address: "Cherry Tree Hill, St. Peter, Barbados",
    image_url: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800",
    images: ["https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800"],
    rating: 4.7,
    is_featured: true,
    is_premium_content: true,
    locked: false,
    tags: ["history", "rum", "plantation", "gardens"],
    opening_hours: "Sun-Fri: 10:00 AM - 3:30 PM",
  },
  {
    spot_id: "seed-seven-mile-beach",
    name: "Seven Mile Beach",
    description:
      "Jamaica's most famous stretch of white sand running along Negril's coast with crystal clear waters and stunning sunsets.",
    short_description: "Iconic 7-mile stretch of paradise",
    category: "beach",
    country: "jamaica",
    location: "Norman Manley Boulevard, Negril, Jamaica",
    address: "Norman Manley Boulevard, Negril, Jamaica",
    image_url: "https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=800",
    images: ["https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=800"],
    rating: 4.8,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["beach", "sunset", "swimming", "romantic"],
    opening_hours: "daily: Open 24 hours",
  },
  {
    spot_id: "seed-ricks-cafe",
    name: "Rick's Cafe",
    description:
      "The legendary cliff-jumping bar where thrill-seekers leap into crystal waters while watching Jamaica's most famous sunset.",
    short_description: "Legendary cliff diving and sunset bar",
    category: "bar",
    country: "jamaica",
    location: "West End Road, Negril, Jamaica",
    address: "West End Road, Negril, Jamaica",
    image_url: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=800",
    images: ["https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=800"],
    rating: 4.6,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["cliff diving", "sunset", "bar", "adventure"],
    opening_hours: "daily: 12:00 PM - 10:00 PM",
  },
  {
    spot_id: "seed-dunns-river-falls",
    name: "Dunn's River Falls",
    description:
      "Climb 600 feet of terraced waterfalls cascading into the Caribbean Sea. An iconic Jamaican adventure that has thrilled visitors for decades.",
    short_description: "Iconic 600ft climbable waterfall",
    category: "adventure",
    country: "jamaica",
    location: "Ocho Rios, St. Ann, Jamaica",
    address: "Ocho Rios, St. Ann, Jamaica",
    image_url: "https://images.unsplash.com/photo-1563299796-17596ed6b017?w=800",
    images: ["https://images.unsplash.com/photo-1563299796-17596ed6b017?w=800"],
    rating: 4.7,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["waterfall", "adventure", "nature", "swimming"],
    opening_hours: "daily: 8:30 AM - 4:00 PM",
  },
  {
    spot_id: "seed-maracas-beach",
    name: "Maracas Beach",
    description:
      "Trinidad's most popular beach nestled between lush green mountains and famous for its iconic Bake and Shark vendors.",
    short_description: "Trinidad's beloved beach with famous Bake & Shark",
    category: "beach",
    country: "trinidad",
    location: "North Coast Road, Maracas Bay, Trinidad",
    address: "North Coast Road, Maracas Bay, Trinidad",
    image_url: "https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?w=800",
    images: ["https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?w=800"],
    rating: 4.5,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["beach", "local food", "mountains", "family"],
    opening_hours: "daily: 6:00 AM - 6:00 PM",
  },
  {
    spot_id: "seed-pigeon-point-beach",
    name: "Pigeon Point Beach",
    description:
      "Tobago's most photographed beach with its iconic thatched jetty, powdery white sand, and calm turquoise waters.",
    short_description: "Postcard-perfect beach with iconic jetty",
    category: "beach",
    country: "trinidad",
    location: "Pigeon Point, Tobago",
    address: "Pigeon Point, Tobago",
    image_url: "https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=800",
    images: ["https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=800"],
    rating: 4.8,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["beach", "photography", "swimming", "romantic"],
    opening_hours: "daily: 9:00 AM - 5:00 PM",
  },
  {
    spot_id: "seed-cable-beach",
    name: "Cable Beach",
    description:
      "Nassau's premier beach featuring crystal-clear waters and pristine white sand with plenty of public access.",
    short_description: "Nassau's premier resort beach",
    category: "beach",
    country: "bahamas",
    location: "West Bay Street, Nassau, Bahamas",
    address: "West Bay Street, Nassau, Bahamas",
    image_url: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800",
    images: ["https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800"],
    rating: 4.6,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["beach", "resort", "swimming", "family"],
    opening_hours: "daily: Open 24 hours",
  },
  {
    spot_id: "seed-atlantis-paradise-island",
    name: "Atlantis Paradise Island",
    description:
      "The ultimate Caribbean resort destination featuring a marine habitat, water park, casino, and world-class dining.",
    short_description: "Mega resort with marine habitat and water park",
    category: "hotel",
    country: "bahamas",
    location: "Paradise Island, Bahamas",
    address: "Paradise Island, Bahamas",
    image_url: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800",
    images: ["https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800"],
    rating: 4.5,
    is_featured: true,
    is_premium_content: true,
    locked: false,
    tags: ["resort", "aquarium", "water park", "casino"],
    opening_hours: "daily: Open 24 hours",
  },
  {
    spot_id: "seed-pig-beach",
    name: "Pig Beach",
    description:
      "The world-famous swimming pigs of Exuma create one of the most unique wildlife encounters in the Caribbean.",
    short_description: "Famous swimming pigs of Exuma",
    category: "attraction",
    country: "bahamas",
    location: "Big Major Cay, Exuma, Bahamas",
    address: "Big Major Cay, Exuma, Bahamas",
    image_url: "https://images.unsplash.com/photo-1604937455095-ef2fe3d46f4d?w=800",
    images: ["https://images.unsplash.com/photo-1604937455095-ef2fe3d46f4d?w=800"],
    rating: 4.9,
    is_featured: true,
    is_premium_content: false,
    locked: false,
    tags: ["animals", "boat tour", "photography", "adventure"],
    opening_hours: "daily: By boat tour only",
  },
];

const STATIC_EXPERIENCES = [
  {
    experience_id: "seed-sunset-catamaran-cruise",
    name: "Sunset Catamaran Cruise",
    description:
      "Sail Barbados' west coast on a luxury catamaran as the sun dips below the horizon. Includes open bar, snorkeling with sea turtles, and a gourmet dinner.",
    short_description: "Luxury sailing with turtles and sunset views",
    category: "tour",
    country: "barbados",
    images: ["https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?w=800"],
    image_url: "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?w=800",
    price: 150,
    duration_minutes: 240,
    max_participants: 30,
    includes: ["Open bar", "Dinner", "Snorkeling gear", "Towels"],
    requirements: ["Swimming ability recommended"],
    rating: 4.9,
  },
  {
    experience_id: "seed-island-safari-adventure",
    name: "Island Safari Adventure",
    description:
      "Explore hidden Barbados in a rugged 4x4 vehicle. Visit hidden beaches, climb to stunning viewpoints, and discover the island's best-kept secrets.",
    short_description: "4x4 adventure through hidden Barbados",
    category: "adventure",
    country: "barbados",
    images: ["https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800"],
    image_url: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800",
    price: 95,
    duration_minutes: 300,
    max_participants: 8,
    includes: ["Transportation", "Lunch", "Drinks", "Guide"],
    requirements: ["Comfortable with off-road driving"],
    rating: 4.8,
  },
  {
    experience_id: "seed-mount-gay-rum-tour",
    name: "Mount Gay Rum Distillery Tour",
    description:
      "Visit the world's oldest rum distillery and learn the art of rum-making. Includes a guided tour and tasting session.",
    short_description: "Tour world's oldest rum distillery",
    category: "tour",
    country: "barbados",
    images: ["https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=800"],
    image_url: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=800",
    price: 65,
    duration_minutes: 90,
    max_participants: 20,
    includes: ["Guided tour", "Rum tasting", "Souvenir glass"],
    requirements: ["Must be 18+ for tasting"],
    rating: 4.7,
  },
  {
    experience_id: "seed-private-beach-horseback-riding",
    name: "Private Beach Horseback Riding",
    description:
      "Gallop along pristine beaches at sunrise or sunset. Perfect for beginners and experienced riders alike.",
    short_description: "Horseback riding on pristine beaches",
    category: "adventure",
    country: "barbados",
    images: ["https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?w=800"],
    image_url: "https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?w=800",
    price: 120,
    duration_minutes: 120,
    max_participants: 6,
    includes: ["Horse", "Helmet", "Guide", "Photos"],
    requirements: ["Weight limit 220 lbs", "Long pants recommended"],
    rating: 4.9,
  },
  {
    experience_id: "seed-blue-lagoon-private-tour",
    name: "Blue Lagoon Private Tour",
    description:
      "Explore the mystical Blue Lagoon where fresh spring water meets the Caribbean Sea. Includes bamboo raft ride, lunch, and swimming.",
    short_description: "Mystical lagoon adventure with bamboo rafting",
    category: "adventure",
    country: "jamaica",
    images: ["https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?w=800"],
    image_url: "https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?w=800",
    price: 85,
    duration_minutes: 240,
    max_participants: 10,
    includes: ["Bamboo raft", "Lunch", "Guide", "Transportation"],
    requirements: ["Swimming ability"],
    rating: 4.8,
  },
  {
    experience_id: "seed-bob-marley-nine-mile-tour",
    name: "Bob Marley Nine Mile Tour",
    description:
      "Visit the birthplace and final resting place of reggae legend Bob Marley with live music and an authentic Jamaican lunch.",
    short_description: "Pilgrimage to Bob Marley's birthplace",
    category: "tour",
    country: "jamaica",
    images: ["https://images.unsplash.com/photo-1508854710579-5cecc3a9ff17?w=800"],
    image_url: "https://images.unsplash.com/photo-1508854710579-5cecc3a9ff17?w=800",
    price: 75,
    duration_minutes: 300,
    max_participants: 15,
    includes: ["Transportation", "Guide", "Lunch", "Entry fees"],
    requirements: [],
    rating: 4.7,
  },
  {
    experience_id: "seed-caroni-swamp-boat-tour",
    name: "Caroni Swamp Boat Tour",
    description:
      "Cruise through mangrove forests to witness thousands of Scarlet Ibis returning to roost at sunset.",
    short_description: "Sunset Scarlet Ibis spectacle",
    category: "tour",
    country: "trinidad",
    images: ["https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800"],
    image_url: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800",
    price: 45,
    duration_minutes: 180,
    max_participants: 20,
    includes: ["Boat ride", "Guide", "Binoculars"],
    requirements: ["Insect repellent recommended"],
    rating: 4.8,
  },
  {
    experience_id: "seed-swimming-pigs-excursion",
    name: "Swimming Pigs Excursion",
    description:
      "Boat trip to Big Major Cay to swim with the famous Exuma pigs. Also includes snorkeling at Thunderball Grotto.",
    short_description: "Swim with famous Exuma pigs",
    category: "adventure",
    country: "bahamas",
    images: ["https://images.unsplash.com/photo-1604937455095-ef2fe3d46f4d?w=800"],
    image_url: "https://images.unsplash.com/photo-1604937455095-ef2fe3d46f4d?w=800",
    price: 195,
    duration_minutes: 420,
    max_participants: 12,
    includes: ["Boat ride", "Snorkel gear", "Lunch", "Drinks"],
    requirements: ["Swimming ability", "Comfortable on boats"],
    rating: 4.9,
  },
];

function matchesSearch(item, search) {
  const needle = String(search || "").trim().toLowerCase();
  if (!needle) return true;

  const haystack = [
    item.name,
    item.description,
    item.short_description,
    item.location,
    ...(Array.isArray(item.tags) ? item.tags : []),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return haystack.includes(needle);
}

function matchesExperienceCategory(itemCategory, requestedCategory) {
  if (!requestedCategory) return true;
  if (itemCategory === requestedCategory) return true;
  if (requestedCategory === "attraction" && itemCategory === "tour") return true;
  if (requestedCategory === "tour" && itemCategory === "attraction") return true;
  return false;
}

export function getStaticFallbackSpots({
  country = "barbados",
  category = "",
  search = "",
  limit = 50,
} = {}) {
  return STATIC_SPOTS.filter((spot) => {
    if (country && spot.country !== country) return false;
    if (category && spot.category !== category) return false;
    return matchesSearch(spot, search);
  }).slice(0, limit);
}

export function getStaticFallbackSpotById(spotId) {
  return STATIC_SPOTS.find((spot) => spot.spot_id === spotId) || null;
}

export function getStaticFallbackExperiences({
  country = "barbados",
  category = "",
  limit = 50,
} = {}) {
  return STATIC_EXPERIENCES.filter((experience) => {
    if (country && experience.country !== country) return false;
    return matchesExperienceCategory(experience.category, category);
  }).slice(0, limit);
}

export function getStaticFallbackExperienceById(experienceId) {
  return STATIC_EXPERIENCES.find((experience) => experience.experience_id === experienceId) || null;
}
